import { render, staticRenderFns } from "./UserAuthView.vue?vue&type=template&id=3a0feec8&scoped=true&"
import script from "./UserAuthView.vue?vue&type=script&lang=ts&"
export * from "./UserAuthView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0feec8",
  null
  
)

export default component.exports